import { styled } from '@nykaa/ui-components';
import { OVERLAY_ZINDEX } from 'shared/styles/base';

export const RouteStage = styled.div`
  display: contents;
  &[data-moving='true'] {
    display: block;
    position: fixed;
    inset: 0;
    height: 100%;
    overflow: hidden;
    background: ${({ theme }) => theme.colors.surface};
    will-change: transform;
    z-index: ${OVERLAY_ZINDEX};
  }
`;

export const CarouselStage = styled.div`
  position: fixed;
  inset: 0;
  height: 100%;
  z-index: ${OVERLAY_ZINDEX};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface};
  &[data-moving='true'] { will-change: transform; }
  &[data-inactive='true'] { visibility: hidden; pointer-events: none; }
`;
